export default __webpack_public_path__ + "static/media/submit-form-ss.dbf292fe.jpg";